import { render, staticRenderFns } from "./wbjhList.vue?vue&type=template&id=11135672&"
import script from "./wbjhList.vue?vue&type=script&lang=js&"
export * from "./wbjhList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports